import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CloseIcon } from '@edusynch/edusynch-svg-icons';
import { Selectors as AppSelectors } from 'modules/Core/AppSlice';
import { Selectors as AuthSelectors } from 'modules/Auth/AuthSlice';
import { useMediaQuery } from 'modules/Core/Hooks';
import * as S from './SidebarHeader.styles';

const CollapseIcon = ({ color = 'currentColor', width = 16, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.2666 3.93359L4.40039 8L8.2666 12.0664L7.06641 13.333L2 8L7.06641 2.66699L8.2666 3.93359ZM13.5996 3.93359L9.7334 8L13.5996 12.0664L12.4004 13.333L7.33301 8L12.4004 2.66699L13.5996 3.93359Z"
      fill={color}
    />
  </svg>
);
CollapseIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

const SidebarHeader = ({ logo, onToggleExpanded, onClose, whitelabelName }) => {
  const { expanded } = useSelector(AppSelectors.sidebar);
  const session = useSelector(AuthSelectors.selectAuthData);
  const isMobile = useMediaQuery('(max-width: 767.98px)');

  const displayName =
    session?.user?.group?.name || whitelabelName || 'EduSynch';

  return (
    <S.Header $expanded={expanded}>
      {expanded || isMobile ? (
        <>
          <S.LogoWhitelabelWrapper>
            <S.LogoWrapper as={NavLink} to="/dashboard">
              <img src={logo} alt="EduSynch logo" />
            </S.LogoWrapper>
            <S.WhitelabelText>
              <S.YouAreIn>You are in</S.YouAreIn>
              <S.WhitelabelName>{displayName}</S.WhitelabelName>
            </S.WhitelabelText>
          </S.LogoWhitelabelWrapper>

          <S.RightActions>
            {isMobile ? (
              <S.CloseButton
                type="button"
                onClick={onClose}
                aria-label="Close menu"
              >
                <CloseIcon color="currentColor" width={24} height={24} />
              </S.CloseButton>
            ) : (
              <S.CollapseButton
                type="button"
                onClick={onToggleExpanded}
                aria-label="Collapse sidebar"
              >
                <S.CollapseIconWrapper $expanded={expanded}>
                  <CollapseIcon color="currentColor" width={16} height={16} />
                </S.CollapseIconWrapper>
              </S.CollapseButton>
            )}
          </S.RightActions>
        </>
      ) : (
        <S.CollapsedHeaderContent>
          <S.LogoWrapper as={NavLink} to="/dashboard">
            <img src={logo} alt="EduSynch logo" />
          </S.LogoWrapper>
          <S.CollapsedRightActions>
            <S.CollapseButton
              type="button"
              onClick={onToggleExpanded}
              aria-label="Expand sidebar"
              $collapsed
            >
              <S.CollapseIconWrapper $expanded={expanded}>
                <CollapseIcon color="currentColor" width={16} height={16} />
              </S.CollapseIconWrapper>
            </S.CollapseButton>
          </S.CollapsedRightActions>
        </S.CollapsedHeaderContent>
      )}
    </S.Header>
  );
};

SidebarHeader.propTypes = {
  logo: PropTypes.string.isRequired,
  whitelabelName: PropTypes.string,
  onToggleExpanded: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

SidebarHeader.defaultProps = {
  whitelabelName: 'EduSynch',
  onClose: () => {},
};

export default SidebarHeader;
